import { getAccessToken } from '@/lib/tokenStorage';

import { enhancedApi } from '../api/baseApi';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface WorkflowHistoryEntry {
  id: string;
  workflowId: string;
  workflowName: string;
  entityId: string;
  entityName: string;
  correlationId: string;
  status: string;
  startedAt: string;
  completedAt: string | null;
  errorMessage: string | null;
}

async function fetchApi<T>(
  url: string,
): Promise<{ data: T } | { error: { status: number | string; data: string } }> {
  try {
    const token = getAccessToken();
    const response = await fetch(`${API_BASE_URL}${url}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'X-Tunnel-Authorization': `tunnel ${import.meta.env.VITE_DEV_TUNNEL_TOKEN}`,
      },
      credentials: 'include',
    });

    if (!response.ok) {
      const error = await response.text();
      return { error: { status: response.status, data: error } };
    }

    const data: T = await response.json();
    return { data };
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    return { error: { status: 'FETCH_ERROR', data: message } };
  }
}

export const workflowHistoryApi = enhancedApi.injectEndpoints({
  endpoints: (build) => ({
    getWorkflowHistory: build.query<WorkflowHistoryEntry[], string>({
      queryFn: async (entityId) =>
        fetchApi<WorkflowHistoryEntry[]>(`/api/workflow/history/${entityId}`),
      providesTags: ['WorkflowHistory'],
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
  }),
});

export const { useGetWorkflowHistoryQuery } = workflowHistoryApi;
